export default "__VITE_ASSET__CNsghlG1__"